module.exports = __webpack_public_path__ + "static/media/6.88efab2f.png";